import { FlexBox } from '@airship-platform/jam-web/components';
import React from 'react';
import { Product, useProductsQueryFilterParams } from '../../../data-access';
import { ProductCardWithActions } from '../../add-products';
import { ProductsQueryProvider } from '../contexts/ProductsQueryContext';
import ProductsQueryHeader from './ProductsQueryHeader';
import ProductsResultsSummary from './ProductsResultsSummary';
import { CategoriesListProps } from './categories/CategoriesList';

export interface ProductsQueryProps {
  renderProductAction: (product: Product) => React.ReactNode;
  renderCategoryItem?: CategoriesListProps['renderCategoryItem'];
  showDescription?: boolean;
}

const ProductsQuery: React.FC<ProductsQueryProps> = ({
  renderProductAction,
  renderCategoryItem,
  showDescription,
}) => {
  const { isInitialised } = useProductsQueryFilterParams();

  return (
    <ProductsQueryProvider>
      <FlexBox flexDirection="column" gap={4} width="100%">
        {isInitialised && (
          <>
            <ProductsQueryHeader renderCategoryItem={renderCategoryItem} />
            <ProductsResultsSummary />
          </>
        )}

        <ProductCardWithActions showDescription={showDescription}>
          {renderProductAction}
        </ProductCardWithActions>
      </FlexBox>
    </ProductsQueryProvider>
  );
};

export default ProductsQuery;
